import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import { configurationAttributeType, defaultMoreOptionsConfiguationValues, moreOptions, newConfigurationNames } from '../../types'
import "./MoreOptionsConfiguration.css"
import { doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import store from '../../stateManagement/store'
import * as Sentry from "@sentry/react";
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { openPopup } from '../../stateManagement/actions/popupActions'
import GenricMultiSelect from '../../components/Input/GenericMultiSelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { Loader } from '../../components/loader/Loader'
import { Autocomplete, TextField } from '@mui/material'
import { Role } from '../../components/userModal/userModalType'
import ConfigComparePopup from '../../components/popup/ConfigComparePopup'
import ImportConfig from '../../components/importConfig/ImportConfig'

export const defaultMoreOptions: defaultMoreOptionsConfiguationValues  =  {
    morePageWidget: {
    "name": "morePageWidget",
    "type": "list",
    "value": [
        {
            "name": "About",
            "type": "moreOptions",
            "image": "assets/images/About.svg",
            "label": "About"
          },
          {
            "name": "Support",
            "type": "moreOptions",
            "image": "assets/images/Support.svg",
            "label": "Support"
          },
          {
            "name": "FAQs",
            "type": "moreOptions",
            "image": "assets/images/FAQ.svg",
            "label": "FAQs"
          }
    ],
    "docUrl": "",
    "description": "more options configuration",
    "possibleVals": [
        {
            "name": "About",
            "type": "moreOptions",
            "image": "assets/images/About.svg",
            "label": "About",
            "compulsory": true
        },
        {
            "name": "Support",
            "type": "moreOptions",
            "image": "assets/images/Support.svg",
            "label": "Support",
            "compulsory": false
        },
        {
            "name": "FAQs",
            "type": "moreOptions",
            "image": "assets/images/FAQ.svg",
            "label": "FAQs",
            "compulsory": false
        },
        {
            "name": "Terms and Conditions",
            "type": "moreOptions",
            "image": "assets/svg/change_password.svg",
            "label": "Terms and Conditions",
            "compulsory": false
        },
        {
            "name": "Change Password",
            "type": "moreOptions",
            "image": "assets/svg/change_password.svg",
            "label": "Change Password",
            "compulsory": true
        },
        {
            "name": "Logout",
            "type": "moreOptions",
            "image": "assets/images/Logout.svg",
            "label": "Logout",
            "compulsory": true
        },{
            "name": "Share The App",
            "type": "moreOptions",
            "image": "assets/svg/share_the_app.svg",
            "label": "Share The App",
            "compulsory": false
        },{
            "name": "Customer Service",
            "type": "moreOptions",
            "image": "assets/svg/customer_service.svg",
            "label": "Customer Service",
            "compulsory": false
        },{
            "name": "Privacy Policy",
            "type": "moreOptions",
            "image": "assets/svg/privacy_policy.svg",
            "label": "Privacy Policy",
            "compulsory": false
        },{
            "name": "invoiceTracking",
            "type": "moreOptions",
            "image": "assets/svg/invoice.svg",
            "label": "Invoice Details",
            "compulsory": false
        },
        {
          "name": "Consumer Promo",
          "type": "moreOptions",
          "image": "assets/images/prmo.svg",
          "label": "Consumer Promo",
          "compulsory": false
        },
        {
          "name": "Promo History",
          "type": "moreOptions",
          "image": "assets/images/About.svg",
          "label": "Promo History",
          "compulsory": false
        }
      ]
  }
}

const MoreOptionsConfiguration = () => {
  const [retailerConfig, setRetailerConfig] = useState<configurationAttributeType<moreOptions[]>[]>([]);
  const [values, setValues] = useState<defaultMoreOptionsConfiguationValues>(deepClone(defaultMoreOptions));  
  const [availableMoreOptions,setAvailableMoreOptions] = useState<string[]>([]);
  const [selectedMoreOptions,setSelectedMoreOptions] = useState<string[]>([]);  
  const [showLoader,setShowLoader] = useState<boolean>(false);
  const [role,setRole] = useState<string>("");
  const [appRoles,setAppRoles] = useState<string[]>(store.getState()?.manageRoleState?.allRoles ?? []);
  const maxValue = 8, minValue = 3;

  const getMoreOptionConfiguration = async () => {
    try {
      setShowLoader(true);
      const resp = await getNewConfiguration(`${role}_app_layout_configuration` as newConfigurationNames);

      const retailer_app_layout_config: configurationAttributeType<moreOptions[]>[] = resp?.domainValues??[];
      const morePageWidget = retailer_app_layout_config.find(config => config.name === "morePageWidget");

      let finalValues = morePageWidget? [...morePageWidget.value] :  values.morePageWidget.value;
      
      finalValues = finalValues.map((option: moreOptions) => {
          const possibleValObj = values.morePageWidget.possibleVals.find((possibeValOption: any) => {
              return possibeValOption.name === option.name;
          });
          return {
              ...option,
              compulsory: possibleValObj?.compulsory || false
          }
      })
      //adding compulsory options
      for(let possibleVal of values.morePageWidget.possibleVals){
          const isPresent = finalValues.find((valueOption: moreOptions) => valueOption.name === possibleVal.name);
          if(possibleVal.compulsory && !isPresent){
              finalValues.push(possibleVal);
          }
      }
      values.morePageWidget.value = finalValues;

      const moreOptions = values.morePageWidget.possibleVals.filter((possibleValOption: moreOptions) => {
          return !values.morePageWidget.value.find((valueOption: moreOptions) => possibleValOption.name === valueOption.name);
      }).map((option: moreOptions) => option.label);

      setRetailerConfig(retailer_app_layout_config);
      setValues({...values});
      setAvailableMoreOptions(moreOptions);
      setShowLoader(false);
    } catch (err) {
      // Sentry.captureException(err);
    }
  }

  useEffect(() => {
    if(role) getMoreOptionConfiguration();
  }, [role]);

  function handleSelectedMoreOptions(selectedOptions: string[]){
    setSelectedMoreOptions(selectedOptions);
  }
  function handleAddMoreOptions(){
        const newMoreOptionValues = selectedMoreOptions.map((selectedOption: string) => {
            const moreOptionObj = values.morePageWidget.possibleVals.find((moreOption: moreOptions) => moreOption.label === selectedOption);
            return { 
                ...moreOptionObj
            };
        })
        values.morePageWidget.value = [...values.morePageWidget.value, ...newMoreOptionValues ];
        const newAvailableMoreOptions = availableMoreOptions.filter((availableOption: string) => {
            return !selectedMoreOptions.find((selectedOption: string) => {
                return selectedOption === availableOption;
            })
        })
        setValues({...values});
        setSelectedMoreOptions([]);
        setAvailableMoreOptions(newAvailableMoreOptions);
  }
  function handleRemove(targetLabel: string){
    const filteredValues = values.morePageWidget.value.filter((moreOption: moreOptions) => {
        return moreOption.label !== targetLabel;
    })
    values.morePageWidget.value = filteredValues;
    setValues({...values});
    setAvailableMoreOptions([targetLabel,...availableMoreOptions]);
  }
  function validateMoreOptionConfig(){
    if(values.morePageWidget.value.length>maxValue){
        return `More Options Items can be ${maxValue} at max`;
    }else if(values.morePageWidget.value.length<minValue){
        return `More Options Items must be atleast ${maxValue} `;
    }
    return "";
  }
  const saveConfiguration = async (preview?: boolean) => {
    const message = validateMoreOptionConfig();
    if(message!==""){
        openPopup("Alert",message);
        return;
    }

      try {
        let result = {...values};
        result.morePageWidget.value = result.morePageWidget.value.map((moreOption: moreOptions) => {
            const { name, label, image, type } = moreOption;
            return {
                name,
                label,
                image,
                type
            }
        });
        const configName:newConfigurationNames = `${role}_app_layout_configuration` as newConfigurationNames;

        const convertedVals = [...retailerConfig];
        Object.keys(result).forEach(key=>{
          const moreOptionsObject = convertedVals.find(config=>config.name === key)
          if(moreOptionsObject){
            moreOptionsObject.value = result[key].value;
          }else{
            const configObj = {...result[key]};
            Reflect.deleteProperty(configObj, 'possibleVals');
            convertedVals.push(configObj);
          }
        })
        await doFinalConfigSubmit(configName,convertedVals);
      } catch (err) {
        // Sentry.captureException(err);
        console.log("err===", err)
        openPopup('Error',"Validation Error occured")
      }
  }
  function handleDragOnEnd(result: DropResult) {
    if(result.destination!==null){
      const items = Array.from(values.morePageWidget.value) as moreOptions[];
      const [reorderedItem] = items.splice(result.source.index, 1);
      if (result.destination)
        items.splice(result.destination.index, 0, reorderedItem);

       values.morePageWidget.value = items; 
       setValues({...values});
    }
  }



  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
      retailer_app_layout_configuration:['morePageWidget']
    })
    for(const configObject of newConfigs){
        await doFinalConfigSubmit(configObject.domainType, configObject.domainValues)
    }
    getMoreOptionConfiguration();
  }
  const [importConfigState,setImportConfigState] = useState(false);


  return (
    <div className="more_options_config_container">
      <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={[`${role}_app_layout_configuration`]} importConfigCallback={importConfiguration} />
      <ConfigurationHeader importConfiguration={()=>{setImportConfigState(true)}} heading={"More Option Configuration"} disable={!role || showLoader} saveConfiguration={() => saveConfiguration(false)} showConfirmPopup={true} />
      <div className="config_form_container">
        <BorderHeading>Role</BorderHeading>
        <div className='footer_config_body_container'>
          <Autocomplete 
              disablePortal
              id="appRoleSelection"
              options={appRoles}
              value={role}
              size="small"
              onChange={(event,value) => {
                if(value) setRole(value);
              }}
              renderInput={(params) => <TextField {...params} label="Select Role" />}
          />
        </div>
        {role && (!showLoader?(<><div className="form_header">
          <BorderHeading>Select the more options</BorderHeading>
        </div>
        <div className='more_options_config_body_container'>
            <div className='more_options_config_multiselect_container'>
                <GenricMultiSelect
                    className="more_options_config_multiselect"
                    options={availableMoreOptions}
                    label={"Select More Options"}
                    selectedOptions={selectedMoreOptions}
                    handleMultiSelectState={handleSelectedMoreOptions}
                    isRequired={false}
                    params={{ size: "small" }}
                />
                <FontAwesomeIcon
                    onClick={handleAddMoreOptions}
                    className="more_options_config_plus_icon"
                    icon={faCirclePlus}
                />
            </div>
            <DragDropContext onDragEnd={handleDragOnEnd}>
            <Droppable droppableId="droppableMoreOptionsItems">
                {(provided) => (
                    <div className="more_options_configuration_options_container" {...provided.droppableProps}
                    ref={provided.innerRef}>
                    {
                        values.morePageWidget.value.map((moreOption: moreOptions,index: number) => {
                            return (
                                <Draggable 
                                    key={moreOption.name}
                                    draggableId={moreOption.name}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div className='card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <div className="item_card" >
                                                <span>
                                                <FontAwesomeIcon  className='transfer_list_grip_lines_icon' icon={faGripLines} />
                                                {moreOption.label}
                                                </span>
                                                {!moreOption.compulsory?<span className='homepage_icon_container'>
                                                <span className='circle_icon' onClick={() => handleRemove(moreOption.label)}><span className='hyphen_icon' /></span>
                                                </span>: <></>}
                                        </div>
                                        
                                    </div>
                                    )}
                                
                                </Draggable>
                            )
                        })
                    }
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>
        </div></>):<Loader />)}
      </div>
    </div>
  )
}

export default MoreOptionsConfiguration;